import { useCompanyTypeFormData } from '../../features/company-type/stores/company-type-store';
import { useYourDetailsValues } from '../../features/your-details/stores/your-details.store';
import { useCompanyDetailsApiPayload } from '../../features/company-details/stores/company-details.store';
import { useServiceNeedsFormData } from '../../features/service-needs/stores/service-needs-store';
import { useProjectDetailsFormData } from '../../features/project-details/stores/project-details.store';
import {
  useUploadDocumentsStore,
  uploadedFileRegistry,
} from '../../features/upload-documents/stores/upload-documents.store';
import { serviceOptions } from '../../shared/constants';

export function useOnboardingPayload() {
  const companyTypeFormData = useCompanyTypeFormData();
  const yourDetailsFormData = useYourDetailsValues();
  const getCompanyDetailsApiPayload = useCompanyDetailsApiPayload();
  const serviceNeedsFormData = useServiceNeedsFormData();
  const projectDetailsFormData = useProjectDetailsFormData();

  const getCurrentStepFormData = (stepId: string) => {
    switch (stepId) {
      case 'company-type': {
        const payloadData = {
          companyType:
            companyTypeFormData.companyType === 'pif-owned'
              ? companyTypeFormData.companyStatus
              : companyTypeFormData.companyType,
        };
        return { ...payloadData } as Record<string, unknown>;
      }
      case 'your-details': {
        // Include companyType from the store for BFF validation
        const companyType =
          companyTypeFormData.companyType === 'pif-owned'
            ? companyTypeFormData.companyStatus
            : companyTypeFormData.companyType;

        return {
          ...yourDetailsFormData,
          companyType,
        } as Record<string, unknown>;
      }
      case 'company-details': {
        // Use the getApiPayload method to get properly formatted data with labels
        return getCompanyDetailsApiPayload() as Record<string, unknown>;
      }
      case 'project-details':
        return { ...projectDetailsFormData, country: 'SA' } as Record<
          string,
          unknown
        >;
      case 'upload-documents': {
        const { uploadedFiles } = useUploadDocumentsStore.getState().formData;
        const formData = new FormData();
        uploadedFiles.forEach((f) => {
          const file = uploadedFileRegistry.get(f.id);
          if (file) formData.append('file', file);
        });
        return formData;
      }
      case 'service-needs': {
        // Include companyType from the store for BFF validation
        const companyType =
          companyTypeFormData.companyType === 'pif-owned'
            ? companyTypeFormData.companyStatus
            : companyTypeFormData.companyType;

        // Map selectedServices IDs to their corresponding labels
        const selectedServicesLabels =
          (serviceNeedsFormData.selectedServices || []).map(
            (serviceId: string) => {
              const serviceOption = serviceOptions.find(
                (option) => option.id === serviceId
              );
              return serviceOption ? serviceOption.value : serviceId; // fallback to ID if label not found
            }
          ) || [];

        return {
          ...serviceNeedsFormData,
          selectedServices: selectedServicesLabels, // Send labels instead of IDs
          companyType,
        } as Record<string, unknown>;
      }
      default:
        return {} as Record<string, unknown>;
    }
  };

  return { getCurrentStepFormData };
}
